forestControllers.controller('sbLiterebiController', function($scope, sbLiteris) {

    $scope.sbLiteris = sbLiteris || [];

    $scope.setLiteri = function(num){

        /**
         * If literi is already same $watch handler defined in parent controller will not trigger
         * and view will not update so we run handler manually in this case.
         */
        if($scope.barati.locations.literi == num){
            $scope.updateState();
        }

        $scope.barati.locations.literi = num;
    };

    $scope.newLiteri = function(){
        var num = $scope.sbLiteris.length > 0 ? $scope.sbLiteris[$scope.sbLiteris.length - 1].literi + 1 : 1;

        $scope.setLiteri(num);
    };

});